'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * https://w3c.github.io/aria-practices/#combobox
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-select-only.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-both.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-list.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-none.html
 *
 * @param props BaseComboboxProps
 * @returns FunctionComponent<BaseComboboxProps>
 */ const BaseCombobox = (props)=>{
    const { className , disabled , divProps , editable , readOnly , required , textareaProps , ...otherProps } = props;
    return editable ? /*#__PURE__*/ React__default.default.createElement("textarea", _extends({}, textareaProps, otherProps, {
        "aria-disabled": disabled,
        "aria-haspopup": "listbox",
        "aria-readonly": readOnly,
        "aria-required": required,
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        className: classnames__default.default({
            'bf-combobox': true,
            'bf-combobox__input': true,
            [`${className}`]: !!className
        }),
        disabled: disabled,
        readOnly: readOnly,
        required: required,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "combobox",
        rows: 1,
        spellCheck: false
    })) : /*#__PURE__*/ React__default.default.createElement("div", _extends({}, divProps, otherProps, {
        "aria-disabled": disabled,
        "aria-readonly": readOnly,
        "aria-required": required,
        "aria-haspopup": "listbox",
        className: classnames__default.default({
            'bf-combobox': true,
            'bf-combobox__div': true,
            [`${className}`]: !!className
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "combobox",
        tabIndex: 0
    }));
};

exports.BaseCombobox = BaseCombobox;
//# sourceMappingURL=base-combobox.js.map
